<template>
  <div class="master-detail">
    <div class="master">
      <p class="master__heading">Our Values</p>
      <div
        class="master-item"
        v-for="item in items"
        :key="item.id"
        @mouseover="debounceHandleMasterItemHover($event, item)"
        :class="activeItemId === item.id ? 'active' : ''"
      >
        <span v-text="item.title"/>
      </div>
    </div>
    <div class="detail">
      <div
        :ref="`detail-item-${item.id}`"
        class="detail-item"
        v-for="item in items"
        :key="item.id"
      >
        <div class="detail-item__content">
          <canvas :ref="`canvas-${item.id}`"></canvas>
          <p v-text="item.subtext"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DotLottie } from '@lottiefiles/dotlottie-web';
import debounce from 'lodash/debounce';

export default {
  name: 'MasterDetail',
  props: {
    items: Array
  },
  data () {
    return {
      activeItemId: '',
      lottieInstances: {},
    };
  },
  created () {
    this.activeItemId = this.items[0].id;
  },
  mounted () {
    for (const item of this.items) {
      const lottie = new DotLottie({
        src: `/${item.file}`,
        canvas: this.$refs[`canvas-${item.id}`][0],
        renderConfig: {
          freezeOnOffscreen: false,
        },
      });
      this.lottieInstances[item.id] = lottie;
    }
    this.$activeDetailItem().addClass('active');
    this.debounceHandleMasterItemHover = debounce(
      this.handleMasterItemHover,
      300
    );
    document.addEventListener('aos:in:values-widget', () => {
      const lottie = this.lottieInstances[this.activeItemId];
      if (!lottie.isLoaded) {
        lottie.addEventListener('load', () => {
          lottie.setFrame(0);
          lottie.play();
        });
      } else {
        lottie.setFrame(0);
        lottie.play();
      }
    });
  },
  methods: {
    handleMasterItemHover (event, item) {
      if (this.activeItemId === item.id) return;
      const $lastActiveDetailItem = this.$activeDetailItem();
      this.activeItemId = item.id;
      const $activeDetailItem = this.$activeDetailItem();
      $activeDetailItem.addClass('active');
      $lastActiveDetailItem.removeClass('active');
      const lottie = this.lottieInstances[item.id];
      lottie.setFrame(0);
      lottie.play();
    },
    $activeDetailItem () {
      return $(this.$refs[`detail-item-${this.activeItemId}`]);
    }
  }
};
</script>
